import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Text } from "@zillow/constellation";
import { SizePropType } from "./prop-types.esm.js";
import { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } from "./constants.esm.js";
const UpsellHeading = ({
  children,
  size
}) => /* @__PURE__ */ jsx(ForegroundText, { as: "p", fontType: getHeadingFont(size), marginBottom: getHeadingMarginBottom(size), children });
const ForegroundText = styled(Text).withConfig({
  displayName: "UpsellHeading__ForegroundText",
  componentId: "sc-1pug80p-0"
})(["color:var(--heading);"]);
function getHeadingFont(size) {
  switch (size) {
    case "xs":
      return {
        default: "h4",
        [BREAKPOINT_DESKTOP]: "h5"
      };
    case "sm":
      return "h4";
    case "md":
      return {
        default: "h4",
        [BREAKPOINT_TABLET]: "h3"
      };
    case "lg":
      return {
        default: "h4",
        [BREAKPOINT_TABLET]: "h3",
        [BREAKPOINT_DESKTOP]: "h1"
      };
    default:
      throw new Error(`Unexpected size of "${size}"`);
  }
}
function getHeadingMarginBottom(size) {
  switch (size) {
    case "xs":
      return void 0;
    case "sm":
      return "sm";
    case "md":
    case "lg":
      return {
        default: "sm",
        [BREAKPOINT_TABLET]: "md"
      };
    default:
      throw new Error(`Unexpected size of "${size}"`);
  }
}
UpsellHeading.propTypes = {
  children: PropTypes.node.isRequired,
  size: SizePropType.isRequired
};
export {
  UpsellHeading as default
};
